import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import BannerSection from "./HomePageComponents/BannerSection";
import GoalGallerySection from "./HomePageComponents/GoalGallerySection";
// import SwiperSection from './HomePageComponents/SwiperSection';
// import SubscribeSection from './HomePageComponents/SubscribeSection';
const LandingPage = () => {
  return (
    <>
      <Header />
      <BannerSection />
      <GoalGallerySection />
      {/* <SwiperSection/> */}
      {/* <SubscribeSection /> */}
      <Footer />
    </>
  );
};

export default LandingPage;
